module.exports = __webpack_public_path__ + "img/6H.8875fac4.svg";